import React from 'react';
import PropTypes from 'prop-types';

import Autocomplete from 'react-autocomplete';

import {graphql, createRefetchContainer} from 'react-relay';
import AppService from '../service/AppService';
import AppConfigService from '../service/AppConfigService';
import AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

import WebMediaQuery from './WebMediaQuery';
import TdWebService from '../service/TdWebService';
import {Message} from '@aperza/ui';
import PathUtil from '../util/PathUtil';

/**
 * There are 2 modes
 *
 * If onSuggestChange is null, Suggest will independently handle the keyword change.
 *
 * If onSuggestChange is NOT null, keyword change will be handled by the parent component.
 * If the parent component has more than one Suggest component which must have the same keyword,
 * the parent component must handle the keyword change in order to synchronize the keyword value across
 * multiple Suggest components.
 */
class Suggest extends React.Component {

  isIME = false;

  static propTypes = {
    suggestSearch: PropTypes.any,
    suggestKeyword: PropTypes.any,
    onSuggestChange: PropTypes.func, //Determine different operation modes.
    rfType: PropTypes.string, //TD identifier to determine the location of the Suggest component
    inputClassName: PropTypes.string,
    tdId: PropTypes.string,
    disableMarketplaceBanner: PropTypes.bool,
  };

  static defaultProps = {
    inputClassName: '',
  };

  constructor(props) {
    super(props);

    let keyword = AppConfigService.getSearchKeyword()?AppConfigService.getSearchKeyword():'';

    this.state = {
      keyword: props.onSuggestChange?props.suggestKeyword:keyword,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.suggestKeyword != prevProps.suggestKeyword) {
      this.setState({
        keyword: this.props.suggestKeyword,
      });
    }
  }

  onChange(e) {
    let keyword = e.target.value;
    this.setState({
      keyword: keyword?keyword:''
    });

    //https://aperza.atlassian.net/browse/AB-5486
    if (!AppConfigService.isAperzaSearchCatalogResultPage() &&
      !AppConfigService.isAperzaSearchItemResultPage() &&
      !AppConfigService.isAperzaSearchNewsResultPage() &&
      !AppConfigService.shouldShowMarketplaceTopBanner()
    ) {
      this.refreshQuery(keyword);
    }

    if (this.props.onSuggestChange) {
      this.props.onSuggestChange(keyword);
    }
  }

  refreshQuery(keyword) {
    let appConfig:AppConfig = AppService.appConfig();
    //console.log('Suggest refreshQuery serviceType', appConfig.serviceType);
    if ([AppConfig.APERZA_SEARCH,AppConfig.APERZA_EC].includes(appConfig.serviceType)) {
      let locale = appConfig.langCode;

      this.props.relay.refetch(
        {
          keyword: keyword,
          langCode: locale,
        },
        null,
        (error) => {
          if (error) {
            console.log('Suggest refreshQuery error', error);
          }
        },
        {force: false}
      )
    }

  }

  onClickSuggestButton() {
    let val = this.state.keyword;
    //console.log('Suggest onClickSuggestButton', val);
    this.onSelect(val.trim());
  }

  onSelect(val) {
    //console.log('onSelect val', val);
    if (val && val.length > 0) {
      let rfType = this.props.rfType?this.props.rfType:'1101';

      let pathname = AppConfigService.getPath();
      let origin = AppConfigService.getOrigin();
      let searchWebHost = appConfig.searchWebHost;
      let langCode = appConfig.langCode;
      let encodedVal = encodeURIComponent(val);

      let url='#';
      if (PathUtil.isSearchCatalogPage(pathname, langCode) || PathUtil.isCatalogPage(pathname, langCode) || appConfig.isAperzaCatalog) {
        url = `${searchWebHost}/${langCode}/s/catalog/?k=${encodedVal}&rf=${rfType}&ss=1`;
      } else if (appConfig.serviceType === AppConfig.APERZA_NEWS) {
        url = `${origin}/?s=${encodeURIComponent(val)}`;
      } else if (pathname.startsWith(`/${langCode}/s/news/`)) {
        url = `${searchWebHost}/${langCode}/s/news/?k=${encodedVal}&rf=${rfType}&ss=1`;
      } else {
        url = `${searchWebHost}/${langCode}/s/model/?k=${encodedVal}&rf=${rfType}&ss=1`;
        if (AppConfigService.shouldShowMarketplaceTopBanner() || !this.props.disableMarketplaceBanner) {
          url = `https://ec${appConfig.baseComDomain}/${langCode}/s/item/?k=${encodedVal}&rf=${rfType}&ss=1`;
        }
      }

      return TdWebService.search(this.props.tdId, val, url)
        .then(() => {
          window.location.href = url;
        })
    }
  }

  onInputKeyDown(e) {
    if (e.key == 'Enter' && !this.isIME) {
      this.onClickSuggestButton();
    }
  }

  onCompositionStart(e) {
    this.isIME = true;
  }

  onCompositionEnd(e) {
    this.isIME = false;
  }

  render() {

    let {
      suggestSearch,
      suggestKeyword,
      onSuggestChange,
      rfType,
    } = this.props;

    let {
      keyword,
    } = this.state;

    let isMainPage = AppService.isMainPage();
    let isSearchResult = AppConfigService.isAperzaSearchResultPage();
    let isSearchNewsResult = AppConfigService.isAperzaSearchNewsResultPage();

    //console.log('Suggest keyword', keyword);

    let items = [];
    if (suggestSearch && Array.isArray(suggestSearch.search)) {
      items = suggestSearch.search.map((product) => {
        return {
          label: product.productKeyword,
          productType: product.productType,
        }
      })
    }

    let wrapperStyle = {
      display: 'inline-block',
      position: 'relative',
    };



    if (onSuggestChange) {
      wrapperStyle.width = '100%';
    }
    // if (!onSuggestChange) {
    //   wrapperStyle = {
    //     width: '100%',
    //     display: 'flex',
    //     flexFlow: 'column',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //   }
    // }



    return (
      <div className="suggest-container">
        <Autocomplete
          getItemValue={(item) => item.label}
          items={items}
          wrapperStyle={wrapperStyle}
          renderInput={(props) => {
            //console.log('Autocomplete props', props);
            return (
              <div className={`suggest-input-container ${isSearchResult||isSearchNewsResult?'search-result':''}`}>

                <div className={`suggest-input ${isMainPage?'aw-main-page':''}`}>
                  {onSuggestChange && !isSearchResult && !isSearchNewsResult && false &&
                    <WebMediaQuery mobileOnly={true}>
                      <i className="fa fa-search" aria-hidden="true"/>
                    </WebMediaQuery>
                  }
                  {
                    rfType == '1102' &&
                    <div className="suggest-input-note">
                      <Message messageId="suggest.title" />
                    </div>
                  }
                  <input type="text" className={this.props.inputClassName} {...props}
                         onKeyDown={::this.onInputKeyDown}
                         onCompositionStart={::this.onCompositionStart}
                         onCompositionEnd={::this.onCompositionEnd}
                  />
                </div>
                <button className={`suggest-button ${this.props.inputClassName} ${isSearchResult||isSearchNewsResult?'search-result':''}`}
                        onClick={::this.onClickSuggestButton}><i className="fa fa-search" aria-hidden="true"></i></button>
              </div>
            )
          }}
          renderMenu={(items, value, style) => {
            if (items.length > 0) {
              return <div className={`suggest-list ${isMainPage?'aw-main-page':''}`} children={items}/>
            } else {
              return <div style={{display: 'none'}}></div>
            }

          }}
          renderItem={(item, isHighlighted) =>
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }} className="suggest-item">
              <span className="name">{item.label}</span><span className="category">{item.productType}</span>
            </div>
          }
          value={keyword}
          onChange={::this.onChange}
          onSelect={::this.onSelect}
        />
      </div>
    )
  }

}

export default createRefetchContainer(Suggest, {
    suggestSearch: graphql`
      fragment Suggest_suggestSearch on SuggestSearch @argumentDefinitions(keyword: {type: "String", defaultValue: ""}, langCode: {type: "String"}) {
          search(keyword: $keyword, langCode: $langCode) {
              productKeyword
              productType
          }
      }
  `}
  , graphql`
    query SuggestRefetchQuery($keyword:String, $langCode:String) {
        suggestSearch {
            ...Suggest_suggestSearch @arguments(keyword: $keyword, langCode: $langCode)
        }
    }
  `
);
